export function Content (pEditor)
{
  let isInTextArea = false,
      isRawContentEmpty = false,
      saveRawContent;


  this.getHtmlData = () =>
  {
    if (pEditor.pThis.isObjValid > 1 && BEditor.domHelpers.$(pEditor.iFrameId, pEditor.$winContent) && (pEditor.iFrameDoc) && (pEditor.iFrameDoc.body))
    {
      return pEditor.iFrameDoc.body.innerHTML;
    }
    else if (pEditor.extParameters.initialContent)
    {
      return pEditor.extParameters.initialContent.content;
    }
    else if (isInTextArea)
    {
      return pEditor.inContainer.value;
    }
    else if (BEditor.domHelpers.$(pEditor.idIn, pEditor.$winContent) && BEditor.domHelpers.$(pEditor.idIn, pEditor.$winContent).innerHTML != null)
    {
      return BEditor.domHelpers.$(pEditor.idIn, pEditor.$winContent).innerHTML;
    }
    else
    {
      return null;
    }
  };


  this.getHtmlDataLength = () =>
  {
    var htmlLength = this.getHtmlData();
    return ((htmlLength) ? htmlLength.length : -1);
  };


  this.getTextData = () =>
  {
    var str;

    if (pEditor.pThis.isObjValid > 1 && BEditor.domHelpers.$(pEditor.iFrameId, pEditor.$winContent) && (pEditor.iFrameDoc) && (pEditor.iFrameDoc.body))
    {
      str = (BEditor.browser.isIE) ? pEditor.iFrameDoc.body.innerText : pEditor.iFrameDoc.body.textContent;
      str = str.replace(/[\n\r\t]+/g, '');
      return str;
    }
    else
    {
      return null;
    }
  };


  this.getTextDataLength = () =>
  {
    var textLength = this.getTextData();
    return ((textLength) ? textLength.length : -1);
  };


  this.getData = (isSafeModules, args = {}) =>
  {
    var domains,
        htmlContent;

    if (!pEditor.extParameters.initialContent)
    {
      if (!BEditor.domHelpers.$(pEditor.idIn, pEditor.$winContent))
      {
        return { htmlContent: null, state: false };
      }
      else
      {
        isInTextArea = (BEditor.domHelpers.$(pEditor.idIn, pEditor.$winContent).nodeName.toUpperCase() == 'TEXTAREA');

        if (BEditor.domHelpers.$(pEditor.idIn, pEditor.$winContent).innerHTML == null || (isInTextArea && BEditor.domHelpers.$(pEditor.idIn, pEditor.$winContent).value == null))
        {
          return { htmlContent: null, state: false };
        }
      }
    }

    if (pEditor.displayMode === 'view' || pEditor.pThis.isObjValid != 2 || (BEditor.domHelpers.$(pEditor.iFrameId, pEditor.$winContent) && pEditor.iFrameDoc && pEditor.iFrameDoc.body && pEditor.iFrameDoc.body.innerHTML && pEditor.iFrameDoc.body.innerHTML.indexOf('##WA###BlankHTMLPageForEditorContentNew###WA##') !== -1))
    {
      htmlContent = pEditor.extParameters.initialContent ? pEditor.extParameters.initialContent.content : (isInTextArea ? BEditor.domHelpers.$(pEditor.idIn, pEditor.$winContent).value : BEditor.domHelpers.$(pEditor.idIn, pEditor.$winContent).innerHTML);
      htmlContent = pEditor.anchor.restoreLinksToAnchors(htmlContent);

      if (!pEditor.isMultiEditorMode)
      {
        domains = BEditor.environment.getAdditionalDomainNames();
        htmlContent = BEditor.urlConverter.convertUrls(htmlContent, domains);
      }

      if (htmlContent != null && htmlContent.replace(/(?:[\s\n\r]+|(?:&nbsp;|<br[^>]*>|<p>&nbsp;<\/p>)+)/ig, '') != '')
      {
        return { htmlContent: htmlContent, state: true };
      }
      else
      {
         return { htmlContent: null, state: false };
      }
    }

    var iframeInnerHtmlAvailable = ((BEditor.domHelpers.$(pEditor.iFrameId, pEditor.$winContent) && pEditor.iFrameDoc && pEditor.iFrameDoc.body) || isInTextArea) ? true : false;

    htmlContent = (iframeInnerHtmlAvailable) ? pEditor.contentCleaner.getCleanHTML(((isSafeModules) ? true : false), true, args) : (pEditor.extParameters.initialContent ? pEditor.extParameters.initialContent.content : (isInTextArea ? pEditor.contentCleaner.getCleanHTML(((isSafeModules) ? true : false), true, args) : BEditor.domHelpers.$(pEditor.idIn, pEditor.$winContent).innerHTML));
    htmlContent = htmlContent || '';

    if (BEditor.browser.isIE)
    {
      if (isRawContentEmpty && htmlContent.replace(/\s*<p>&nbsp;<\/p>\s*/i, '') === '')
      {
        htmlContent = saveRawContent;
      }
    }
    else
    {
      if (isRawContentEmpty && htmlContent.replace(/\s*<p><br><\/p>\s*/i, '') === '')
      {
        htmlContent = saveRawContent;
      }
    }

    htmlContent = pEditor.removeWaContentMarker(htmlContent);
    htmlContent = pEditor.anchor.restoreLinksToAnchors(htmlContent);
    htmlContent = htmlContent.replace(/\sdata-autoabs=['"]?true['"]?/, '');
    htmlContent = htmlContent.replace(/^\s*((?:.|[\n\r])*)\s*$/, "$1");

    if (!pEditor.isMultiEditorMode)
    {
      domains = BEditor.environment.getAdditionalDomainNames();
      htmlContent = BEditor.urlConverter.convertUrls(htmlContent, domains);
    }

    return { htmlContent: htmlContent, state: (htmlContent != null && htmlContent.replace(/(?:[\s\n\r]+|(?:&nbsp;|<br[^>]*>|<p>&nbsp;<\/p>)+)/ig, '') != '') };
  };


  this.saveData = (isSafeModules) =>
  {
    var ret;

    if (pEditor.idOut && BEditor.domHelpers.$(pEditor.idOut, pEditor.$winContent) && BEditor.domHelpers.$(pEditor.idOut, pEditor.$winContent).value != null)
    {
      ret = this.getData(isSafeModules);

      if (ret.htmlContent != null)
      {
        BEditor.domHelpers.$(pEditor.idOut, pEditor.$winContent).value = ret.htmlContent;
      }

      return ret.state;
    }

    return false;
  };


  Object.defineProperty(this, 'isInTextArea', { get: () => isInTextArea, set: v => { isInTextArea = v }});
  Object.defineProperty(this, 'isRawContentEmpty', { get: () => isRawContentEmpty, set: v => { isRawContentEmpty = v }});
  Object.defineProperty(this, 'saveRawContent', { get: () => saveRawContent, set: v => { saveRawContent = v }});
}